<template>
    <div>
        <el-tabs type="border-card">
            <el-tab-pane label="资讯生成列表">
                <div style="background: #ffffff; position: relative">
                    <div class="search-condition-con" :class="'show'">
                        <div class="search-condition">
                            <span class="label">动态分类</span>
                            <div class="input-condition">
                                <el-select v-model="condition.type_id" placeholder="请选择" clearable>
                                    <el-option v-for="item in typeList" :key="item.id" :label="item.name"
                                        :value="item.id"></el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="search-condition">
                            <span class="label">模板名称</span>
                            <div class="input-condition">
                                <el-input v-model="condition.template_name" maxlength="30"
                                    placeholder="请输入模板名称" clearable></el-input>
                            </div>
                        </div>
                        <div class="search-condition">
                            <span class="label">动态标题</span>
                            <div class="input-condition">
                                <el-input v-model="condition.title" maxlength="30"
                                    placeholder="请输入动态标题" clearable></el-input>
                            </div>
                        </div>
                        <div class="search-condition">
                            <span class="label">站点</span>
                            <div class="input-condition">
                                <site-auto-complete v-model="condition.site_id" :clueId="1" :init-choose-first="false"
                                    :owned="true" ref="siteAutoComplete" @created="initData"
                                    clearable></site-auto-complete>
                            </div>
                        </div>
                        <div class="search-condition search-condition-time" style="min-width: 400px">
                            <span class="label">生成时间</span>
                            <div class="input-condition">
                                <el-date-picker v-model="condition.time" type="datetimerange" range-separator="至"
                                    start-placeholder="开始日期" end-placeholder="结束日期" align="right"
                                    value-format="yyyy-MM-dd HH:mm" format="yyyy-MM-dd HH:mm"
                                    @change="condition.timestamp = ''" clearable>
                                </el-date-picker>
                            </div>
                        </div>
                    </div>
                    <div class="btn-condition">
                        <el-button type="primary" @click="handleSearch()">查 询</el-button>
                        <el-button @click="resetSearch()">清空条件</el-button>
                        <el-button @click="batchPush()" v-permission="'operating.house-trend-model-manage.trend-list.delete'">批量发布</el-button>
                        <el-button @click="batchDelete()" v-permission="'operating.house-trend-model-manage.trend-list.delete'">批量删除</el-button>
                    </div>
                </div>
                <el-table :data="list" style="width: 100%" :highlight-current-row="true" stripe tooltip-effect="dark"
                    ref="multipleTable" v-loading="isLoading" header-cell-class-name="table-back" class="list-table"
                    @selection-change="handleSelectionChange">
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column label="动态ID" prop="id" align="center"></el-table-column>
                    <el-table-column label="动态标题" prop="title" align="center"></el-table-column>
                    <el-table-column label="楼盘名称" prop="house_name" align="center"></el-table-column>
                    <el-table-column label="站点" prop="site_name" align="center"></el-table-column>
                    <el-table-column label="动态分类" prop="type_name" align="center"></el-table-column>
                    <el-table-column label="模板名称" prop="template_name" align="center"></el-table-column>
                    <el-table-column label="添加人" prop="operator" align="center"></el-table-column>
                    <el-table-column label="生成时间" prop="created_at" align="center"></el-table-column>
                    <el-table-column label="操作"  width="300px" align="center">
                        <template slot-scope="scope">
                            <el-button size="mini" @click="openEdit(scope.row)" v-permission="'operating.house-trend-model-manage.trend-list.edit'"
                                >编辑</el-button>
                            <el-button  size="mini" @click="handleDelete(scope.row.id)" v-permission="'operating.house-trend-model-manage.trend-list.delete'"
                                >删除</el-button>
                            <el-button  size="mini" @click="handlePush(scope.row.id)" v-permission="'operating.house-trend-model-manage.trend-list.push'"
                                >发布</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <template v-if="list.length > 0">
                    <el-pagination background layout="total,prev, pager, next" :current-page="condition.page"
                        :total="condition.total" :page-size="condition.per_page"
                        @current-change="currentChange"></el-pagination>
                </template>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
import {getAdminHouseTrends,deleteHouseTrends,pushHouseTrends} from '@/service/dynamicModel'
import { NEWS_MODEL } from "@/config/index";
import SiteAutoComplete from "@/components/auto-complete/site-auto-complete";
export default {
    components: {
        SiteAutoComplete
    },
    data() {
        return {
            typeList:[{
                id:1,
                name:"楼盘动态"
            },{
                id:2,
                name:"开盘信息"
            },{
                id:3,
                name:"交房信息"
            },{
                id:4,
                name:"证件信息"
            }],
            list: [],
            selectList:[],
            condition: {
                type_id: "",
                site_id: "",
                title: "",
                template_name:"",
                time: "",
                per_page: 10,
                total: 0,
                page: 1,
            },
            isLoading: false,
        };
    },
    mounted() {
        // this.typeList = NEWS_MODEL.news_types;
    },
    methods: {
        handleSearch() {
            this.condition.page = 1;
            this.initData();
        },
        resetSearch() {
            this.condition = {
                type_id: "",
                site_id: "",
                title: "",
                template_name:"",
                time: "",
                per_page: 10,
                total: 0,
                page: 1,
            };
            this.initData();
        },
        batchPush(){
            if(!this.selectList || this.selectList.length <= 0){
                this.$message({
                    message: "请先选择要批量发布的数据",
                    type: 'error',
                    duration: 3 * 1000
                })
                return 
            }
            this.$confirm("批量发布后动态内容将展示在分站后台与前台页面，是否确认发布所选内容？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                let data = {}
                data.ids = this.selectList.join("_")
                pushHouseTrends(data)
                .then(() => {
                    this.$message({
                    type: "success",
                    message: "发布成功"
                    });
                    this.initData();
                })
                .catch(err => {
                    this.$message({
                    type: "error",
                    message: err.message || "发布失败"
                    });
                });
            });
        },
        batchDelete(){
            if(!this.selectList || this.selectList.length <= 0){
                this.$message({
                    message: "请先选择要批量发布的数据",
                    type: 'error',
                    duration: 3 * 1000
                })
                return 
            }
            this.$confirm("批量删除后内容不可恢复，是否确认删除所选内容？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                let data = {}
                data.ids = this.selectList.join("_")
                deleteHouseTrends(data)
                .then(() => {
                    this.$message({
                    type: "success",
                    message: "删除成功"
                    });
                    this.initData();
                })
                .catch(err => {
                    this.$message({
                    type: "error",
                    message: err.message || "删除失败"
                    });
                });
            });
        },
        async initData() {
            // this.list = [];
            this.isLoading = true;

            let query = {
                type_id: this.condition.type_id,
                site_id: this.condition.site_id,
                title: this.condition.title,
                template_name:this.condition.template_name,
                per_page: this.condition.per_page,
                total: this.condition.total,
                page: this.condition.page,
            }
            if (this.condition.time && this.condition.time.length > 1) {
                query.created_at_start = this.condition.time[0];
                query.created_at_end =this.condition.time[1];
            } else {
                delete query.created_at_start;
                delete query.created_at_end;
            }
            await getAdminHouseTrends(query).then((data) => {
              this.condition.total = data.total;
              this.list = data.data;
            });

            //数据请求完毕取消当前页面的loading
            this.isLoading = false;
        },
        currentChange(index) {
            this.condition.page = index;
            this.initData();
        },
        handleSelectionChange(val) {
            this.selectList = val.map(item => {
                return item.id
            });
        },
        openEdit(data) {
            this.$router.push({path: 'edit', query: data})
        },
        handleDelete(id) {
            this.$confirm("删除后内容不可恢复，是否确认删除？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                let data = {}
                data.ids = id
                deleteHouseTrends(data)
                .then(() => {
                    this.$message({
                    type: "success",
                    message: "删除成功"
                    });
                    this.initData();
                })
                .catch(err => {
                    this.$message({
                    type: "error",
                    message: err.message || "删除失败"
                    });
                });
            });
        },
        handlePush(id){
            this.$confirm("发布后动态内容将展示在分站后台与前台页面，是否确认发布所选内容？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                let data = {}
                data.ids = id
                pushHouseTrends(data)
                .then(() => {
                    this.$message({
                    type: "success",
                    message: "发布成功"
                    });
                    this.initData();
                })
                .catch(err => {
                    this.$message({
                    type: "error",
                    message: err.message || "发布失败"
                    });
                });
            });
        }
    },
};
</script>
<style lang="less" scoped>

</style>